import { createApp } from 'vue';
import App from './App.vue';

import router from '@/router';
import i18n from '@/assets/lang';
import '@/assets/styles/global.scss';
import VConsole from 'vconsole';
import { isTestEnv } from '@/utils/orderConfig';

import {
  Button,
  Field,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Divider,
  Image as VanImage,
  ActionSheet,
  List,
  PullRefresh,
  Empty,
  Icon,
  Dialog,
  Toast,
  Search,
  Popover,
  Collapse,
  CollapseItem, Loading
} from 'vant';
import 'vant/lib/index.css';

if (isTestEnv()) {
  const vConsole = new VConsole();
}

const app = createApp(App);

app.use(Button);
app.use(Field);
app.use(CellGroup);
app.use(Checkbox);
app.use(CheckboxGroup);
app.use(Divider);
app.use(VanImage);
app.use(ActionSheet);
app.use(List);
app.use(PullRefresh);
app.use(Empty);
app.use(Loading);
app.use(Icon);
app.use(Dialog);
app.use(Toast);
app.use(Search);
app.use(Collapse);
app.use(CollapseItem);
app.use(Popover);

app.use(i18n);
app.use(router);
app.mount('#app');
